/* AmikoCrochet product page: the mobile sticky Add to cart. (Sets are the reusable set-offers capability.) */
(function () {
  var sticky = document.querySelector('[data-amiko-sticky]');
  var main = document.querySelector('.ProductForm__AddToCart');
  if (sticky && main && 'IntersectionObserver' in window) {
    /* Only once the main button has scrolled up out of view (not while it is still below). */
    new IntersectionObserver(function (entries) { var e = entries[0]; sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }).observe(main);
    sticky.querySelector('[data-amiko-sticky-add]').addEventListener('click', function () { main.click(); });
  }
})();
